import React, { useState, useEffect } from 'react'
import { Link, useRoute } from 'wouter'
import Prism from 'prismjs'
import getTicket from 'services/getTicket'

import sortByDate from 'tools/sortByDate'

import Loader from 'components/Loader'
import NavBar from 'components/NavBar'
import Icon from 'components/Icon'

import './TicketDetail.css'

import getTimeAgo from 'tools/getTimeAgo'
const j2m = require('jira2md')

function TicketDetail ({ params: { id } }) {
  const [isLoading, setLoading] = useState(false)
  const [ticket, setTicket] = useState()
  const [, params] = useRoute('/:back/:id')

  function refreshInfo (e) {
    setLoading(true)
    getTicket(id)
      // .then(t => { console.log(t); return t })
      .then(t => {
        setTicket(t)
        setLoading(false)
        Prism.highlightAll()
      })
      .catch(e => {
        console.log(...e.error)
        setTicket(null)
        setLoading(false)
      })
  }

  useEffect(() => {
    setLoading(true)
    getTicket(id)
      // .then(t => { console.log(t); return t })
      .then(t => {
        setTicket(t)
        setLoading(false)
        Prism.highlightAll()
      })
      .catch(e => {
        console.log(...e.error)
        setTicket(null)
        setLoading(false)
      })
  }, [id])

  return (
    <>
      <NavBar refreshInfo={refreshInfo} />
      <main className='TicketDetail'>
        {isLoading
          ? <Loader />
          : ticket
            ? (
              <>
                <div className='ticket'>
                  <div className='type'><Icon name={ticket.type} /></div>
                  <div className='priority'><Icon name={ticket.priority} /></div>
                  <div className='status'><Icon name={ticket.status} /></div>
                  <div className='summary'>{ticket.summary}</div>
                  <div className='updated'>{getTimeAgo(ticket.updated)}</div>
                  <div className='description' dangerouslySetInnerHTML={{ __html: j2m.jira_to_html(ticket.description) }} />
                  <div className='comments'>
                    {ticket.comments
                      .sort((a, b) => {
                        // Más reciente primero
                        return sortByDate(a.updated, b.updated)
                      })
                      .map(c => {
                        return (
                          <div key={c.id} className='comment'>
                            <div className='updated'>{getTimeAgo(c.updated)}</div>
                            <div className='body' dangerouslySetInnerHTML={{ __html: j2m.jira_to_html(c.body) }} />
                          </div>
                        )
                      })}
                  </div>
                </div>
                <Link href={params.back !== 'ticket' ? `/${params.back}` : '/'}>
                  <p><a href={params.back !== 'ticket' ? `/${params.back}` : '/'}>Volver al listado</a></p>
                </Link>
              </>
              )
            : <p>No ticket</p>}
      </main>
    </>
  )
}

export default TicketDetail
